import React from "react";
import Skill from "./Skiil";
import XD from "../img/xd.png";
import TailwindCss from "../img/tailwind.png";
import Javascript from "../img/javascript.png";
import Reactjs from "../img/react.png";

import nextjs from "../img/nextjs.svg";
const Para2 = () => {
  const mainSkill = [
    { id: 4, name: "TailwindCss", icon: TailwindCss },
    { id: 3, name: "Javascript", icon: Javascript },
    { id: 1, name: "React.js", icon: Reactjs },
    { id: 2, name: "Next.js", icon: nextjs },
    { id: 5, name: "Adobe XD", icon: XD },
  ];
  return (
    <>
      <section aria-label="my skills" className="bg-slate-800 dividewave">
        <div className="flex  items-center h-[80rem] sm:h-[50rem] lg:h-[40rem]">
          <Skill mainSkill={mainSkill} />
        </div>
      </section>
    </>
  );
};

export default Para2;
